import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-grow"
}

import SfxContextBarManager from "src/components/navigation/SfxContextBarManager.vue"
import SfxMainMenuManager from "src/components/navigation/SfxMainMenuManager.vue"
import SfxSearchBarQuick from "src/components/search/SfxSearchBarQuick.vue"
import SfxCurrentUserDisplay from "src/components/special/SfxCurrentUserDisplay.vue"
import { ContextAction, MainMenuType } from "src/util/enums/entityType"
import { userSettingsDialog } from "src/util/functions/dialogs"
import { MenuDataManager, MenuDataNames } from "src/util/types/dataModels/entityDefinition"
import { PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTopNavigationManager',
  props: {
  mainMenuContent: {
    type: Array as PropType<Array<MainMenuType>>,
  },

  // Whatever goes inside that list would appear as disabled in Main menu list
  disableMainMenuContent: Array as PropType<Array<MainMenuType>>,

  hideExtendedMenu: Boolean,

  disableExtendedMenu: Boolean,

  disableMainMenu: Boolean,

  hideSearchBar: Boolean,

  quickActions: Array as PropType<Array<ContextAction>>,

  hideQuickActions: Boolean,

  disableQuickActions: Array as PropType<Array<ContextAction>>,

  contextMenuContent: {
    type: Array as PropType<Array<ContextAction>>,
    default: () => [],
  },

  disableContextMenuContent: Array as PropType<Array<ContextAction>>,

  disableContextMenu: Boolean,

  hideContextMenu: Boolean,

  hideContextBar: Boolean,

  hideSeparator: Boolean,

  hideNotifications: Boolean,

  disableNotifications: Boolean,

  hideTodoIcon: Boolean,

  disableTodoIcon: Boolean,

  homeButton: Object as PropType<MenuDataManager>,

  activeTab: String as PropType<MenuDataNames>,

  activeExtendedTab: String as PropType<MenuDataNames>,

  hideUserDisplay: Boolean,

  // TODO: Set the default to false when we have the Quick search bar working
  disableSearchBar: {
    type: Boolean,
    default: true,
  },

  disableUserDisplay: Boolean,
},
  emits: ["contextSelect"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const { t } = useI18n()
const searchTerm = ref("")
const settingsLabel = t("sfxNavigation.settings")

//endregion

//region Functions

function openUserSettings() {
  if (!props.disableUserDisplay) {
    userSettingsDialog()
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "sfx-top-navigation-manager bg-white" }, {
    default: _withCtx(() => [
      _createVNode(SfxMainMenuManager, {
        "main-menu-content": props.mainMenuContent,
        "disable-main-menu-content": props.disableMainMenuContent,
        "disable-main-menu": props.disableMainMenu,
        "hide-extended-menu": props.hideExtendedMenu,
        "disable-extended-menu": props.disableExtendedMenu,
        "home-button": props.homeButton,
        "active-tab": props.activeTab,
        "active-extended-tab": props.activeExtendedTab
      }, null, 8, ["main-menu-content", "disable-main-menu-content", "disable-main-menu", "hide-extended-menu", "disable-extended-menu", "home-button", "active-tab", "active-extended-tab"]),
      (props.hideSearchBar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : (_openBlock(), _createBlock(SfxSearchBarQuick, {
            key: 1,
            modelValue: searchTerm.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
            class: "q-px-xl",
            disable: props.disableSearchBar
          }, null, 8, ["modelValue", "disable"])),
      (!props.hideContextBar)
        ? (_openBlock(), _createBlock(SfxContextBarManager, {
            key: 2,
            onContextSelect: _cache[1] || (_cache[1] = (item) => emit('contextSelect', item)),
            "quick-actions": props.quickActions,
            "hide-quick-actions": props.hideQuickActions,
            "disable-quick-actions": props.disableQuickActions,
            "context-menu-content": props.contextMenuContent,
            "disable-context-menu-content": props.disableContextMenuContent,
            "hide-context-menu": props.hideContextMenu,
            "disable-context-menu": props.disableContextMenu,
            "hide-separator": props.hideSeparator,
            "hide-notifications": props.hideNotifications,
            "disable-notifications": props.disableNotifications,
            "hide-todo-icon": props.hideTodoIcon,
            "disable-todo-icon": props.disableTodoIcon
          }, null, 8, ["quick-actions", "hide-quick-actions", "disable-quick-actions", "context-menu-content", "disable-context-menu-content", "hide-context-menu", "disable-context-menu", "hide-separator", "hide-notifications", "disable-notifications", "hide-todo-icon", "disable-todo-icon"]))
        : _createCommentVNode("", true),
      (!props.hideUserDisplay)
        ? (_openBlock(), _createBlock(SfxCurrentUserDisplay, {
            key: 3,
            class: "q-ml-xs sfx-top-navigation-manager__user",
            onClick: openUserSettings,
            title: _unref(settingsLabel),
            small: "",
            disable: props.disableUserDisplay
          }, null, 8, ["title", "disable"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})